module.exports = __webpack_public_path__ + "static/prod-infra-1002e99d0df21d74b3da826f9e8bdbf2.png";